var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9989 19.4491L8.81513 17.2653L6.59963 15.0498L8.41308 13.2375L10.6288 15.4533L10.9824 15.8069L11.336 15.4532L18.9035 7.88415L20.7338 9.71444L13.1647 17.2819L13.1645 17.2821L10.9989 19.4491ZM0.5 13.6667C0.5 6.39494 6.39494 0.5 13.6667 0.5C20.9384 0.5 26.8333 6.39494 26.8333 13.6667C26.8333 20.9384 20.9384 26.8333 13.6667 26.8333C6.39494 26.8333 0.5 20.9384 0.5 13.6667ZM24.8621 13.6667C24.8621 7.4843 19.8508 2.46956 13.6667 2.46956C7.4825 2.46956 2.47125 7.4843 2.47122 13.6667C2.47122 19.8492 7.48261 24.8621 13.6667 24.8621C19.8507 24.8621 24.8621 19.8492 24.8621 13.6667Z",
    fill: "white",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.13018a2f903f3064f7db143907edd29f.svg";
export { ForwardRef as ReactComponent };